import { forwardRef, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import TaskAssignmentTable, { TaskAssignmentTableRef } from './TaskAssignmentTable';
import { getAllProjects } from 'src/services/projectDetailService';
import { GetEmployeeProjectDetails } from 'src/services/projectService';
import TaskAssign, { TaskAssignRef } from './TaskAssign';

interface TaskAssignmentViewProps {
  permissions: any;
}

export interface TaskAssignmentViewRef {
  onSubmitToCreate: (data) => void;
  getTasks: () => void;
  project: string;
}

const TaskAssignmentView = forwardRef<TaskAssignmentViewRef, TaskAssignmentViewProps>(({ permissions }, ref) => {
  const appUser = useSelector((state: RootStateType) => state.appReducer?.user);
  const dispatch = useDispatch();
  const TaskAssignmentTableRef = useRef<TaskAssignmentTableRef>(null);

  const [projects, setProjects] = useState<any>([]);
  const [project, setProject] = useState<any>('');

  useEffect(() => {
    const fetchProject = () => {
      if(appUser.Roles.split(',').includes('Super User')){
        getAllProjects().then((res) => {
          const filteredProjects = res.data;
          const newData = [];

          for(let i=0; i < filteredProjects.length; i++){
            newData.push({
              label: filteredProjects[i]?.name,
              value: {
                projectId: filteredProjects[i]?.id,
                projectName: filteredProjects[i]?.name,
                key: filteredProjects[i]?.key,
                isClosed: filteredProjects[i]?.isClosed,
              }
            });
          }
          setProjects(newData);
          setProject(newData[0]?.value)
        });
      } else {
        GetEmployeeProjectDetails(appUser?.EmployeeId).then((res) => {
          const currentDate = new Date();
          let filteredRanges = res?.data?.filter(range => {
            const start = new Date(range.startDate);
            const end = new Date(range.endDate);
            return currentDate < end && currentDate > start;
          });

          let newFilteredRanges = filteredRanges.filter(e => e.role === "Project Manager");
          newFilteredRanges = newFilteredRanges.reduce((acc, item) => {
              if(!acc.includes(e => e.projectCode === item.projectCode)){
                acc.push({
                  label: item?.projectName,
                  value: {
                    projectId: item?.projectId,
                    projectName: item?.projectName,
                    key: item?.projectKey,
                    isClosed: item?.isClosed,
                  }
                })
              }
              return acc;
            },[]);
  
          const filteredList = (newFilteredRanges.filter(e => !e.isClosed) as any[]) || []
          setProjects(filteredList);
          setProject(filteredList[0]?.value)
        });
      }
    }

    fetchProject();
  }, []);

  const setProjectValue = (data) => {
    setProject(data);
  }

  const getTableData = () => {
    if (TaskAssignmentTableRef.current) {
      TaskAssignmentTableRef.current.getAllAssignTasks();
    }
  }

  return (
    <div className='task-management'>
      <TaskAssign
        projectsList={projects}
        permissions={permissions}
        setProjectValue={setProjectValue}
        getTableData={getTableData}/>
      <TaskAssignmentTable
        ref={TaskAssignmentTableRef}
        projectValue={project}
        permissions={permissions}/>
    </div>
  );
});

export default TaskAssignmentView;
